const Menu = [
  {
    label: "Home",
    pathname: "/"
  },
  {
    label: "Dashboard",
    pathname: "/dashboard"
  },
  {
    label: "Signup",
    pathname: "/signup"
  },
  {
    label: "Wizard",
    pathname: "/wizard"
  },
  {
    label: "Cards",
    pathname: "/cards"
  },
  {
    label: "Github",
    pathname: "https://github.com/alexanmtz/material-sense",
    external: true
  }

];

export default Menu;